huppa = {};
huppa.vinnslubu = {};
huppa.vinnslubu.numer = null;
huppa.mjolkurskyrsla = {};
huppa.mjolkurskyrsla.step1 = {};
huppa.mjolkurskyrsla.step1.init = function () {
	$('#newStep1').submit(function () {
		showProgressbar();
		return true;
	});

	$('#skradags').change(function () {
		var params = {
			busnumer: huppa.vinnslubu.numer,
			dagsetning: $(this).val()
		};

		$.get('/mjaltagogn/innlestur/get', params, function (data) {
			var $innlesturMsg = $('div.innlestur-msg');
			if (data) {
				$innlesturMsg.find('strong').html(data.dagsetning);
				$innlesturMsg.show();
			}
			else {
				$innlesturMsg.hide();
			}
		});
	}).trigger('change');
};
huppa.kuaskodun = {};
huppa.kuaskodun.skipulag = {};
huppa.kuaskodun.skipulag.init = function () {
	$('#ollSvaedi-1').change(function () {
		$('#svaedi-element').find('input').attr('checked', $(this).is(':checked'))

	});
};
huppa.eftirlit = {};
huppa.eftirlit.aminning = {};
huppa.eftirlit.aminning.titill = null;
huppa.eftirlit.aminning.texti = null;
huppa.eftirlit.aminning.show = function () {
	var texti = $('<div class="wrapper"></div>').html(huppa.eftirlit.aminning.texti);
	$('<div></div>').html(texti).dialog({
		'autoOpen' : true,
		'height' : 280,
		'width' : 860,
		'title' : huppa.eftirlit.aminning.titill,
		'dialogClass' : 'moyaMessageDialog'
	})
};
huppa.eftirlit.keyra = {};
huppa.eftirlit.keyra.closeWindowLabel = null;
huppa.eftirlit.keyra.dialogTitle = null;
huppa.eftirlit.keyra.skyrslaNumer = null;
huppa.eftirlit.keyra.init = function () {
	var adgerd = '';
	var $afurdaskyrsla = $('#afurdaskyrsla');

	$('input[type="submit"]').click(function (evt) {
		adgerd = evt.target.name;
	});

	$afurdaskyrsla.find('select').change(function () {
		if (null != huppa.eftirlit.keyra.skyrslaNumer) {
			window.location.href = "/eftirlit/index/keyra";
		}
	});

	$afurdaskyrsla.submit(function (e) {
		e.preventDefault(); // don't submit multiple times
		$(this).find('#adgerd').val(adgerd);
		$(this).find('input[type=submit]').attr('disabled', 'disabled');
		this.submit(); // use the native submit method of the form element
	});

	$('#skila-dialog').dialog({
		autoOpen: false,
		width: 550,
		height: 180,
		modal: true,
		buttons: [{
			text: huppa.eftirlit.keyra.closeWindowLabel,
			click: function () {
				$(this).dialog("close");
			}
		}]
	});
};
huppa.eftirlit.keyra.showDialog = function () {
	$('#skila-dialog').dialog('option', 'title', huppa.eftirlit.keyra.dialogTitle)
		.dialog('open')
		.dialog('open');
};

huppa.saeding = {};
huppa.saeding.oskrad = {};
huppa.saeding.oskrad.laga = {};
huppa.saeding.oskrad.laga.init = function () {
	var $kyrNumer = $('#kyr_numer_leit');
	$('#bondi_skyring-element').find('.radio').change(function () {
		if ($(this).val() === 'gripanumer') {
			$kyrNumer.removeAttr('disabled');
		}
		else {
			$kyrNumer.attr('disabled', 'disabled');
		}
	});
};
huppa.erfdamengi = {};
huppa.erfdamengi.innlestur = {};
huppa.erfdamengi.innlestur.init = function () {
	var $syni = $('div.innlestur').find('input.syni');
	var $first = $syni.filter(':first');
	var syniList = [];
	var tegundDefaultValue = 'Tissue';

	$first.focus();

	$syni.bind('blur keypress', function(e) {
		if (e.type === 'blur') {
			return validateSyni($(this));
		}
		else if (e.type === 'keypress') {
			if (e.which === 13) { // Enter button is pressed
				$syni.eq($syni.index(this) + 1).focus();
				return false;
			}
		}
	});

	function validateSyni($elm) {

		$elm.removeClass('error');

		var search = $.grep(syniList, function(e){ return e.value === $elm.val(); });
		if (search.length > 0) {
			$elm.addClass('error');
			$elm.val('');
			$syni.eq($syni.index($elm.get(0))).focus();
		}
		else {
			syniList = syniList.filter(function(el) { return el.id !== $elm.attr('id'); });
			if ($elm.val().trim()) {
				syniList.push({'id' : $elm.attr('id'), 'value' : $elm.val()});
			}
		}
	}

	$(document).delegate('.skra-aukalinu a', 'click', function () {
		var $template = $('.template');
		var currentIndex = parseInt($template.data('index'));
		var $row = $template.clone()
			.removeAttr('class')
			.removeAttr('style')
			.removeAttr('data-index');

		$row.find('input.syni').bind('blur', function () {
			return validateSyni($(this));
		});

		$.each($row.find('[name*="placeholder"]'), function () {
			var $input = $(this);
			$input.attr('id', $input.attr('id').replace('placeholder', currentIndex));
			$input.attr('name', $input.attr('name').replace('placeholder', currentIndex));

			if ($input.hasClass('gripur')) {
				var valueId = $input.attr('id').replace('gripur', 'numer');
				$input.jsonsearch({
					valueId: valueId,
					messageId: null,
					url: '/erfdamengi/syni/aukagripur',
					minLength: 4,
					autoCheck: false,
					afterSelect: function(id, value, label, labelRight, extra) {
						$row.find('.gripanumer').html(label);
						$row.find('.nafn').html(extra.nafn);
						$row.find('.kyn').html(extra.kyn);
						$row.find('.stada').html(extra.stada);
						$('#' + valueId).val(id);
					}
				});
			}

			if ($input.hasClass('select')) {
				$input.val(tegundDefaultValue);
				$input.change(function () {
					tegundDefaultValue = $input.val();
					console.log(tegundDefaultValue);
				});
			}

		});

		$('div.innlestur tfoot').append($row);
		$template.data('index', currentIndex + 1);

		return false;
	});
};

huppa.uppgjor = {};
huppa.uppgjor.init = function () {
	$('#handvirktForm').live('submit', function (e) {
		$('.info').html('<h3>Keyrsla í gangi</h3>');
		$('.errors').empty();
	})
};


if (!String.prototype.format) {
	String.prototype.format = function() {
		var args = arguments;
		return this.replace(/{(\d+)}/g, function(match, number) {
			return typeof args[number] != 'undefined'
				? args[number]
				: match
				;
		});
	};
}

huppa.dates = {};
huppa.dates.init = function () {
	$('input.hasDatepicker').live('blur', function () {
		const regex = /(\d{1,2})[.]?(\d{1,2})[.]?(\d{4})/gm;
		var $this = $(this);
		var value = $this.val();
		var ret = regex.exec(value);

		if (ret != null) {
			[matches, day, month, year] = ret;
			if (matches) {
				$this.val("{0}.{1}.{2}".format(day, month, year));
			}
		}
	});
};
huppa.dates.init();

$(document).ready(function () {
	// User new version of jQuery - Special Case
	var $select2 = $new('#gripur_litur_numer').select2();

	$('.select2').live('focus', function () {
		$select2.select2('open');
	});
});